/**
 * Shared helpers for FC transfer create + entity line-item flows (lot picker, staged rows).
 */

/**
 * @returns {{ numCases: number, numLooseUnits: number }}
 */
export function defaultQuantitiesFromInventoryRow() {
    return { numCases: 0, numLooseUnits: 0 };
}

/**
 * @param {Record<string, unknown>} row
 * @returns {{ lotId: number, locationId: number } | null}
 */
export function readLotAndLocationIds(row) {
    const lotRaw = row.lotId ?? row.lot_id;
    const locRaw = row.warehouseLocationId ?? row.warehouse_location_id;
    const lotId = typeof lotRaw === 'number' ? lotRaw : parseInt(String(lotRaw ?? ''), 10);
    const locationId = typeof locRaw === 'number' ? locRaw : parseInt(String(locRaw ?? ''), 10);
    if (!Number.isFinite(lotId) || lotId <= 0 || !Number.isFinite(locationId) || locationId <= 0) {
        return null;
    }
    return { lotId, locationId };
}

/**
 * Stable client id for staged line items before server ids exist.
 *
 * @param {'create' | 'entity'} [source='create'] - Prefix when `crypto.randomUUID` is unavailable
 * @returns {string}
 */
export function newFCTransferLineItemClientId(source = 'create') {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }
    const slug = source === 'entity' ? 'entity-li' : 'li';
    return `fc-tf-${slug}-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}
